var _path;
import * as React from "react";
function SvgChampagneFlute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 9 2 C 8.843549 2 10.143933 12.844562 11.75 13.908203 L 11.75 22.113281 A 4 0.33162412 0 0 0 8 22.443359 A 4 0.33162412 0 0 0 12 22.775391 A 4 0.33162412 0 0 0 16 22.443359 A 4 0.33162412 0 0 0 12.25 22.113281 L 12.25 13.908203 C 13.843978 12.84149 15.027726 2 15 2 L 9 2 z "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampagneFlute);
export default __webpack_public_path__ + "static/media/ChampagneFlute.ceb8ac9cfc2f2ff6fc745b0378986681.svg";
export { ForwardRef as ReactComponent };